<style lang="less">
.orderlist-view {
  font-size: 14px !important;
  .yd-tab-nav {
    height: 50px;
    li {
      line-height: 50px !important;
      font-size: 14px !important;
      cursor: pointer;
    }
  }

  .yd-preview-item>:first-child {
    text-align-last:left;
  }
}
.order-list {
  .order-item {
    .pay-link {
      color: red;
      padding-left: 10px;
    }
    .yd-preview {
      padding: 30px 0;
    }
  }
  .cartitem-line {
    color: #999;
    margin-top: 10px;
    font-size: 12px;
  }
  .yd-list-title {
    color: #333;
    font-weight: normal;
    text-align: inherit !important;
    height: 80px !important;
    max-height: 80px !important;
    white-space: normal !important;
  }
  .yd-list-theme4 .yd-list-item {
    .yd-list-mes {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 20px;
    }
    .item-title {
      font-size: 14px;
      font-weight: bold;
      color: #505050;
    }
  }
  .yd-list-other {
    align-items: center;
    .flex-row {
      flex: 1;
      padding-right: 20px;
    }
  }
  .yd-list {
    border-bottom: 1px solid #eee;
  }
  .order-item-title {
    background-color: #fff;
    line-height: 60px;
    border-bottom: 1px solid #eee;
    padding: 0 30px;
    span {
      color: #666;
      font-weight: bold;
    }
  }
  .yd-preview-item {
    color: #666;
  }
}

.track-list ul {
  padding: 0;
  margin: 0;
}

.track-list {
  height: 300px;
  //  margin-left: 20px;
  overflow: scroll;
  text-align: left;
}
.track-list li:before {
  content: "";
  border: 3px solid #f3f3f3;
  background-color: #d9d9d9;
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  margin-left: -6px;
  margin-right: 10px;
}
.shipping-status-wrapper {
  text-align: center;
  background: #f3f3f3;
  padding: 10px;
}
</style>

<template>
  <div class="orderlist-view wrap">
    <yd-tab v-model="tabKey" :prevent-default="false" :item-click="itemClick">
      <yd-tab-panel
        v-for="(item, index) in items"
        :key="index"
        :label="item.label"
      >
        <div class="order-list">
          <yd-search
            class="search-container"
            ref="search"
            v-model="keywords"
            placeholder="请输入收货人手机号、快递单号、或订单编号进行检索"
            cancel-text
          />
          <div class="order-item block" v-for="order in list" :key="order.id">
            <div class="order-item-title flex-row flex-sb">
              <span>{{ order.sn }}</span>
              <span
                v-if="order.pay_status != 'UNPAID' || order.status != 'NORMAL'"
                >{{ statusText }}
              </span>
              <span
                v-if="order.pay_status == 'UNPAID' && order.status == 'NORMAL'"
              >
                <a
                  class="pay-link"
                  @click="
                    $router.push({
                      name: 'order',
                      query: { id: order.id, pay: true },
                    })
                  "
                  >去支付 ></a
                >
              </span>
            </div>
            <yd-list theme="4">
              <yd-list-item
                v-for="item in order.items"
                :key="item.id"
                type="link"
                :href="{ name: 'order', query: { id: order.id } }"
              >
                <img
                  slot="img"
                  v-lazy="item.photos[0] + '?x-oss-process=style/thumb-160x160'"
                />
                <div slot="title">
                  <div class="item-title">{{ item.name }}</div>
                  <div class="cartitem-line" v-if="item.color">
                    <span>颜色： {{ item.color }}</span>
                  </div>
                  <div class="cartitem-line" v-if="item.size">
                    <span>尺寸： {{ item.size }}</span>
                  </div>
                </div>
                <yd-list-other slot="other">
                  <div class="flex-row flex-sb">
                    <span class="price"
                      >¥ {{ (item.sale_price / 100).toFixed(2) }}</span
                    >
                    <span style="font-size: 14px">X {{ item.quantity }}</span>
                  </div>
                </yd-list-other>
              </yd-list-item>
            </yd-list>
            <yd-preview :buttons="[]">
              <yd-preview-item>
                <div slot="left">订单金额</div>
                <div slot="right" class="price">
                  ¥{{ (order.order_amount / 100).toFixed(2) }}
                </div>
              </yd-preview-item>
              <yd-preview-item>
                <div slot="left">下单时间</div>
                <div slot="right">{{ order.created_at | moment }}</div>
              </yd-preview-item>
              <yd-preview-item v-if="order.express_name">
                <div slot="left">物流信息</div>
                <div slot="right" @click="showShipping(order)">
                  {{ order.express_name }} {{ order.express_number }}
                  <yd-icon name="search" size="1rem" color="#FF685D" />
                </div>
              </yd-preview-item>
            </yd-preview>
          </div>
        </div>
        <yd-button
          size="large"
          shape="angle"
          bgcolor="#666"
          style="min-width: 60%"
          color="#fff"
          @click.native="loadNextPage"
          v-if="hasNextPage"
          ref="moreBtn"
          >加载更多</yd-button
        >

        <span
          style="
            margin-top: 20px;
            text-align: center;
            width: 100%;
            font-size: 14px;
            display: block;
          "
          v-if="!hasNextPage && list && list.length > 0"
          >没有更多了</span
        >

        <div
          class="flex-col block main-bg"
          style="height: 80vh"
          v-if="item.loaded && item.list.length == 0"
        >
          <div class="flex-col flex-all-center" style="flex: 1; color: #666">
            <v-icon name="flushed" scale="6" />
            <span class="title-title" style="margin-top: 20px; font-size: 14px"
              >您还没有此类型的订单</span
            >
          </div>
        </div>
      </yd-tab-panel>
    </yd-tab>
    <yd-popup v-model="displayShpping" position="center" width="90%">
      <div class="block shipping-status-wrapper" v-if="displayShpping">
        <h2>配送状态</h2>
        <p v-if="shippingStatus.status!=200" style="padding:10px">运单查询失败，状态码为：{{shippingStatus.status}}</p>
        <ul class="track-list" v-if="shippingStatus.status==200">
          <li v-for="(c, index) in shippingStatus.msg.context" :key="index">
            <div slot="left">{{ c.time }}</div>
            <div slot="right">{{ c.desc }}</div>
          </li>
        </ul>
        <yd-button @click.native="displayShpping = false">关闭</yd-button>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import lodash from "lodash";
import moment from "moment";

function elementInViewport(el) {
  let box = el.getBoundingClientRect();

  return box.top < window.innerHeight && box.bottom >= 0;
}

export default {
  name: "order-list",

  data: (com) => {
    //console.log("aaa", com.$store.state.user.credit);

    var tabs = [
      {
        label: "未支付",
        query: { status: "NORMAL", pay_status: "UNPAID" },
        loaded: false,
        list: [],
        nextPage: false,
      },
      {
        label: "待发货",
        query: {
          status: "NORMAL",
          pay_status: "PAID_ON_CREDIT",
          goods_status: "UNSHIPPED",
        },
        loaded: false,
        list: [],
        nextPage: false,
      },
      {
        label: "已完成",
        query: {
          status: "NORMAL",
          pay_status: "PAID",
          goods_status: "SHIPPED",
        },
        loaded: false,
        list: [],
        nextPage: false,
      },
    ];

    if (com.$store.state.user.credit > 0) {
      tabs.push({
        label: "赊账中",
        query: {
          status: "NORMAL",
          pay_status: "ON_CREDIT",
          goods_status: "SHIPPED",
        },
        loaded: false,
        list: [],
        nextPage: false,
      });
    }

    tabs.push({
      label: "已取消",
      query: { status: "CANCELLED" },
      loaded: false,
      list: [],
      nextPage: false,
    });
    return {
      keywords: "",
      tabKey: 0,
      displayShpping: false,
      shippingStatus: false,
      items: tabs,
    };
  },

  computed: {
    statusText() {
      return this.items[this.tabKey].label;
    },
    list() {
      return this.items[this.tabKey].list || [];
    },
    hasNextPage() {
      return this.items[this.tabKey].nextPage != "";
    },
  },

  watch: {
    keywords: _.debounce(async function (value) {
      let resp = await this.$store.dispatch("order/getList", {
        ...this.items[this.tabKey].query,
        page: 1,
        keywords: value,
      });

      this.items[this.tabKey].list = resp.list;
    }, 100),
  },

  filters: {
    moment: function (date) {
      return moment(date).add(8, 'hours').format("YYYY-MM-DD HH:mm:ss");
    },
  },

  methods: {
    async showShipping(order) {
      const shippingStatus = await this.$store.dispatch(
        "order/getShippingStatus",
        order.id
      );

      if (shippingStatus.status == 200) {
        shippingStatus.msg.context = shippingStatus.msg.context.map((o) => {
          return {
            time: moment(o.time * 1000).format("YYYY-MM-DD HH:mm:ss"),
            desc: o.desc,
          };
        });
      }
      this.displayShpping = true;
      this.shippingStatus = shippingStatus;
    },
    async loadNextPage() {
      if (this.loadingNextPage) {
        return;
      }

      this.loadingNextPage = true;
      let key = this.tabKey;

      let resp = await this.$store.dispatch("order/getList", {
        ...this.items[key].query,
        keywords: this.keywords,
        page: this.items[this.tabKey].currentPage + 1,
      });
      this.items[key].list = this.items[key].list.concat(resp.list);
      this.items[key].nextPage = resp.next_page_ur;
      this.items[key].loaded = true;
      this.items[key].currentPage = resp.current_page;

      this.$dialog.loading.close();

      this.loadingNextPage = false;
    },
    async itemClick(key) {
      if (this.items[key].list.length == 0) {
        this.$dialog.loading.open("加载中");

        let resp = await this.$store.dispatch("order/getList", {
          ...this.items[key].query,
          keywords: this.keywords,
        });
        this.items[key].list = resp.list;
        this.items[key].nextPage = resp.next_page_ur;
        this.items[key].loaded = true;
        this.items[key].currentPage = resp.current_page;

        this.$dialog.loading.close();
      }
      this.tabKey = key;
    },
  },

  mounted() {
    this.itemClick(this.tabKey);

    window.onscroll = () => {
      if (this.$refs.moreBtn[this.tabKey]) {
        if (elementInViewport(this.$refs.moreBtn[this.tabKey].$el)) {
          this.loadNextPage();
        }
      }
    };
  },

  unmounted() {
    window.onscroll = null;
  },
};
</script>
